/* eslint no-underscore-dangle: ["error", { "allow": ["_score"] }] */
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { cloneDeep, isEmpty, set } from 'lodash';

import {
  FETCH_ERROR,
  PENDING_PRODUCT_RESULTS,
  RECEIVE_SEARCH_PRODUCTS,
} from '~/client/lib/actions';

/**
 * The initial state of search reducer state.
 *
 */
function getInitialState() {
  return {
    productResults: {
      offers: [],
      count: 0,
    },
    query: {},
    error: false,
  };
}

export default (state = getInitialState(), action = {}) => {
  let newState = state;

  if (isEmpty(state)) {
    return getInitialState();
  }

  switch (action.type) {
    case RECEIVE_SEARCH_PRODUCTS: {
      const { data, query } = action;
      const { offers, total } = data;

      newState = cloneDeep(newState);
      newState.error = false;
      newState.productResults = {
        offers,
        count: total,
      };
      newState.query = query;

      break;
    }
    case PENDING_PRODUCT_RESULTS:
      newState = {
        ...state,
      };
      set(newState, 'productResults.pending', action.pending);
      break;
    case FETCH_ERROR:
      newState = {
        ...state,
      };
      newState.error = true;
      set(newState, 'results.pending', action.pending);
      break;
    default:
    // do nothing
  }

  // Return the new state.
  return newState;
};
